/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v3.0.0
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("whatInput", [], factory);
	else if(typeof exports === 'object')
		exports["whatInput"] = factory();
	else
		root["whatInput"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	module.exports = (function() {

	  'use strict';

	  /*
	    ---------------
	    variables
	    ---------------
	  */

	  // array of actively pressed keys
	  var activeKeys = [];

	  // cache document.body
	  var body;

	  // boolean: true if touch buffer timer is running
	  var buffer = false;

	  // the last used input type
	  var currentInput = null;

	  // form input types
	  var formInputs = [
	    'button',
	    'input',
	    'select',
	    'textarea'
	  ];

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
	  var mouseWheel = detectWheel();

	  // list of modifier keys commonly used with the mouse and
	  // can be safely ignored to prevent false keyboard detection
	  var ignoreMap = [
	    16, // shift
	    17, // control
	    18, // alt
	    91, // Windows key / left Apple cmd
	    93  // Windows menu / right Apple cmd
	  ];

	  // mapping of events to input types
	  var inputMap = {
	    'keydown': 'keyboard',
	    'keyup': 'keyboard',
	    'mousedown': 'mouse',
	    'mousemove': 'mouse',
	    'MSPointerDown': 'pointer',
	    'MSPointerMove': 'pointer',
	    'pointerdown': 'pointer',
	    'pointermove': 'pointer',
	    'touchstart': 'touch'
	  };

	  // add correct mouse wheel event mapping to `inputMap`
	  inputMap[detectWheel()] = 'mouse';

	  // array of all used input types
	  var inputTypes = [];

	  // mapping of key codes to a common name
	  var keyMap = {
	    9: 'tab',
	    13: 'enter',
	    16: 'shift',
	    27: 'esc',
	    32: 'space',
	    37: 'left',
	    38: 'up',
	    39: 'right',
	    40: 'down'
	  };

	  // map of IE 10 pointer events
	  var pointerMap = {
	    2: 'touch',
	    3: 'touch', // treat pen like touch
	    4: 'mouse'
	  };

	  // touch buffer timer
	  var timer;


	  /*
	    ---------------
	    functions
	    ---------------
	  */

	  // allows events that are also triggered to be filtered out for `touchstart`
	  function eventBuffer(event) {
	    clearTimer();
	    setInput(event);

	    buffer = true;
	    timer = window.setTimeout(function() {
	      buffer = false;
	    }, 650);
	  }

	  function bufferedEvent(event) {
	    if (!buffer) setInput(event);
	  }

	  function clearTimer() {
	    window.clearTimeout(timer);
	  }

	  function setInput(event) {
	    var eventKey = key(event);
	    var value = inputMap[event.type];
	    if (value === 'pointer') value = pointerType(event);

	    // don't do anything if the value matches the input type already set
	    if (currentInput !== value) {
	      var activeElement = document.activeElement.nodeName.toLowerCase();

	      if (
	        (
	          // only if the user flag to allow input switching
	          // while interacting with form fields isn't set
	          !body.hasAttribute('data-whatinput-formswitching') &&

	          // support for legacy keyword
	          !body.hasAttribute('data-whatinput-formtyping') &&

	          // only if currentInput has a value
	          currentInput &&

	          formInputs.indexOf(activeElement) > -1
	        ) || (
	          // ignore modifier keys
	          ignoreMap.indexOf(eventKey) > -1
	        )
	      ) {
	        // ignore keyboard typing and do nothing
	      } else {
	        switchInput(value);
	      }
	    }

	    if (value === 'keyboard') logKeys(eventKey);
	  }

	  function switchInput(string) {
	    currentInput = string;
	    body.setAttribute('data-whatinput', currentInput);

	    if (inputTypes.indexOf(currentInput) === -1) inputTypes.push(currentInput);
	  }

	  function key(event) {
	    return (event.keyCode) ? event.keyCode : event.which;
	  }

	  function target(event) {
	    return event.target || event.srcElement;
	  }

	  function pointerType(event) {
	    if (typeof event.pointerType === 'number') {
	      return pointerMap[event.pointerType];
	    } else {
	      return (event.pointerType === 'pen') ? 'touch' : event.pointerType; // treat pen like touch
	    }
	  }

	  // keyboard logging
	  function logKeys(eventKey) {
	    if (activeKeys.indexOf(keyMap[eventKey]) === -1 && keyMap[eventKey]) activeKeys.push(keyMap[eventKey]);
	  }

	  function unLogKeys(event) {
	    var eventKey = key(event);
	    var arrayPos = activeKeys.indexOf(keyMap[eventKey]);

	    if (arrayPos !== -1) activeKeys.splice(arrayPos, 1);
	  }

	  function bindEvents() {
	    body = document.body;

	    // pointer events (mouse, pen, touch)
	    if (window.PointerEvent) {
	      body.addEventListener('pointerdown', bufferedEvent);
	      body.addEventListener('pointermove', bufferedEvent);
	    } else if (window.MSPointerEvent) {
	      body.addEventListener('MSPointerDown', bufferedEvent);
	      body.addEventListener('MSPointerMove', bufferedEvent);
	    } else {

	      // mouse events
	      body.addEventListener('mousedown', bufferedEvent);
	      body.addEventListener('mousemove', bufferedEvent);

	      // touch events
	      if ('ontouchstart' in window) {
	        body.addEventListener('touchstart', eventBuffer);
	      }
	    }

	    // mouse wheel
	    body.addEventListener(mouseWheel, bufferedEvent);

	    // keyboard events
	    body.addEventListener('keydown', eventBuffer);
	    body.addEventListener('keyup', eventBuffer);
	    document.addEventListener('keyup', unLogKeys);
	  }


	  /*
	    ---------------
	    utilities
	    ---------------
	  */

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
	  function detectWheel() {
	    return mouseWheel = 'onwheel' in document.createElement('div') ?
	      'wheel' : // Modern browsers support "wheel"

	      document.onmousewheel !== undefined ?
	        'mousewheel' : // Webkit and IE support at least "mousewheel"
	        'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
	  }


	  /*
	    ---------------
	    init

	    don't start script unless browser cuts the mustard,
	    also passes if polyfills are used
	    ---------------
	  */

	  if (
	    'addEventListener' in window &&
	    Array.prototype.indexOf
	  ) {

	    // if the dom is already ready already (script was placed at bottom of <body>)
	    if (document.body) {
	      bindEvents();

	    // otherwise wait for the dom to load (script was placed in the <head>)
	    } else {
	      document.addEventListener('DOMContentLoaded', bindEvents);
	    }
	  }


	  /*
	    ---------------
	    api
	    ---------------
	  */

	  return {

	    // returns string: the current input type
	    ask: function() { return currentInput; },

	    // returns array: currently pressed keys
	    keys: function() { return activeKeys; },

	    // returns array: all the detected input types
	    types: function() { return inputTypes; },

	    // accepts string: manually set the input type
	    set: switchInput
	  };

	}());


/***/ }
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./~/what-input/dist/what-input.js
// module id = 2
// module chunks = 0